import { ROLES } from "../roles";

export const ROLE_GROUPS = {
  dashboard: [
    ROLES.SUPER_ADMIN,
    ROLES.APP_ADMIN,
    ROLES.SCHOOL_ADMIN,
    ROLES.ADMIN,
    ROLES.FINANCE_ADMIN,
    ROLES.EXAMS_ADMIN,
    ROLES.LIBRARIAN,
    ROLES.COACH,
    ROLES.STAFF,
    ROLES.TEACHER,
    ROLES.STUDENT,
  ],
  admin: [ROLES.SUPER_ADMIN, ROLES.APP_ADMIN, ROLES.SCHOOL_ADMIN, ROLES.ADMIN],
  schoolManagement: [
    ROLES.SUPER_ADMIN,
    ROLES.APP_ADMIN,
    ROLES.SCHOOL_ADMIN,
    ROLES.ADMIN,
    ROLES.FINANCE_ADMIN,
    ROLES.EXAMS_ADMIN,
  ],
  teacherEnabled: [
    ROLES.SUPER_ADMIN,
    ROLES.APP_ADMIN,
    ROLES.SCHOOL_ADMIN,
    ROLES.ADMIN,
    ROLES.FINANCE_ADMIN,
    ROLES.EXAMS_ADMIN,
    ROLES.TEACHER,
  ],
  teacherSelfService: [
    ROLES.SUPER_ADMIN,
    ROLES.APP_ADMIN,
    ROLES.SCHOOL_ADMIN,
    ROLES.ADMIN,
    ROLES.FINANCE_ADMIN,
    ROLES.EXAMS_ADMIN,
    ROLES.TEACHER,
  ],
  finance: [
    ROLES.SUPER_ADMIN,
    ROLES.APP_ADMIN,
    ROLES.SCHOOL_ADMIN,
    ROLES.ADMIN,
    ROLES.FINANCE_ADMIN,
  ],
  exams: [
    ROLES.SUPER_ADMIN,
    ROLES.APP_ADMIN,
    ROLES.SCHOOL_ADMIN,
    ROLES.ADMIN,
    ROLES.EXAMS_ADMIN,
    ROLES.TEACHER,
  ],
  employeeAdmin: [ROLES.SUPER_ADMIN, ROLES.APP_ADMIN, ROLES.SCHOOL_ADMIN, ROLES.ADMIN],
  library: [
    ROLES.SUPER_ADMIN,
    ROLES.APP_ADMIN,
    ROLES.SCHOOL_ADMIN,
    ROLES.ADMIN,
    ROLES.LIBRARIAN,
  ],
  superAdminOnly: [ROLES.SUPER_ADMIN],
  platformAdmin: [ROLES.SUPER_ADMIN, ROLES.APP_ADMIN],
  account: [ROLES.SUPER_ADMIN, ROLES.SCHOOL_ADMIN, ROLES.TEACHER, ROLES.STUDENT],
  results: [
    ROLES.SUPER_ADMIN,
    ROLES.APP_ADMIN,
    ROLES.SCHOOL_ADMIN,
    ROLES.ADMIN,
    ROLES.FINANCE_ADMIN,
    ROLES.EXAMS_ADMIN,
    ROLES.TEACHER,
    ROLES.STUDENT,
  ],
  teacherOnly: [ROLES.TEACHER],
  studentOnly: [ROLES.STUDENT],
};

export const ROLE_HOME_PATH = {
  [ROLES.SUPER_ADMIN]: "/dashboard",
  [ROLES.APP_ADMIN]: "/dashboard",
  [ROLES.SCHOOL_ADMIN]: "/dashboard",
  [ROLES.ADMIN]: "/dashboard",
  [ROLES.TEACHER]: "/dashboard",
  [ROLES.EXAMS_ADMIN]: "/dashboard",
  [ROLES.FINANCE_ADMIN]: "/dashboard",
  [ROLES.LIBRARIAN]: "/dashboard",
  [ROLES.COACH]: "/dashboard",
  [ROLES.STAFF]: "/dashboard",
  [ROLES.STUDENT]: "/dashboard",
};

export const ROLE_PRIORITY = [
  ROLES.SUPER_ADMIN,
  ROLES.APP_ADMIN,
  ROLES.SCHOOL_ADMIN,
  ROLES.ADMIN,
  ROLES.TEACHER,
  ROLES.EXAMS_ADMIN,
  ROLES.FINANCE_ADMIN,
  ROLES.LIBRARIAN,
  ROLES.COACH,
  ROLES.STAFF,
  ROLES.STUDENT,
];
